import { Outlet, RouteObject } from "react-router-dom";
import WelcomePage from "../pages/welcomePage";
import { DomainProvider } from "@4uhub/lib4uhub";
import { DonorsPage } from "../pages/4uDonation/Donors/DonorsPage";
import { Donors } from "../pages/4uDonation/Donors/DonorsForm/Donors";

const donationRoutes: RouteObject[] = [
  {
    index: true,
    element: <WelcomePage />,
  },
  {
    path: "donors",
    element: <Outlet />,
    children: [
      {
        path: "register",
        element: (
          <DomainProvider value={{ domainName: "donor" }}>
            <DonorsPage />
          </DomainProvider>
        ),
      },
      {
        path: "register/new",
        element: (
          <DomainProvider value={{ domainName: "donor" }}>
            <Donors />
          </DomainProvider>
        ),
      },
      {
        path: "register/:id/edit",
        element: (
          <DomainProvider value={{ domainName: "donor" }}>
            <Donors />
          </DomainProvider>
        ),
      },
    ],
  },
];

export default donationRoutes;
